import Link from 'next/link';
import styled from 'styled-components';

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SocialText = styled.span`
  flex-direction: row;
  color: ${({ theme }) => theme.palette.grey};
  padding-left: 8px;
  font-weight: 400;
  line-height: 24px;
  &:hover {
    color: ${({ theme }) => theme.palette.black};
  }
`;

export const ShareItem = styled(Link)`
  display: flex;
  flex-direction: row;
  margin: 0 0 12px 0;
`;

export const ColCustomIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: none;
`;

export const FavoritesContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  cursor: pointer;
  box-shadow: none;
`;
